import styled from 'styled-components';
import { calcResize } from 'components/Layout/styles';
import Image from 'components/Image';
import { Container } from 'react-bootstrap';
import Button from 'components/Button';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';
import DotSVG from 'components/DotSVG';

// background-color: ${props => props.theme.colors.accent};
// background-image: url(${props => props.bgImage});
// background-repeat: no-repeat;
// background-position: left;
// background-size: cover;
// Example of use. Delete if not needed.
export const SDiv = styled.div`
  /* flex for aligning children along column and DESC has flex:1 for stretching it to push button to bottom */
  display: flex;
  flex-direction: column;
  justify-content: center;
  alight-items: center;
  min-height: 250px;
  position: relative;
  z-index: 100;
  background-color: ${props => props.theme.colors.accent};
  ${mediaBreakpointUp(
    'md',
    `
    background-size: 30% 100%;
  `,
  )}
  ${mediaBreakpointUp(
    'xl',
    `
  min-height: 350px;
  `,
  )}
`;

export const STitle = styled.h3`
  display: block;
  font-weight: bold;
  font-size: ${calcResize(20, 35)};
  letter-spacing: 0em;
  line-height: 0.925;
  text-align: center;

  ${mediaBreakpointUp(
    'md',
    `
    text-align: left;
  `,
  )}
`;

export const SDesc = styled.div`
  display: block;
  font-size: ${calcResize(13, 17)};
  flex: 1;
  color: #ffffff;
  text-align: center;
  ${mediaBreakpointUp(
    'md',
    `
    text-align: left;
  `,
  )}
  a {
    color: ${props => props.theme.colors.pastel_blue};
  }
`;

export const SDescPoints = styled.div`
  font-size: ${calcResize(13, 20)};
  font-weight: normal;
`;

export const SBgImage = styled(Image)`
  // font-size: ${calcResize(13, 20)};
  // font-weight: normal;
  position: absolute !important;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  z-index: -1;
`;

export const SContent = styled(Container)`
  /* display: grid; */
  margin-top: ${calcResize(35, 70)};
  margin-bottom: ${calcResize(35, 70)};
  place-items: center;
  background-color: ${props => props.theme.colors.accent};
  grid-gap: 15px;
  padding: 10px;
`;

export const SButton = styled(Button)`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.main};
  border-color: ${props => props.theme.colors.main};
  border-radius: 0px;
  margin-right: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${calcResize(14, 24)};
  width: ${calcResize(150, 250)};
`;

export const SDotSVG = styled(DotSVG)`
  z-index: -1;
  top: 30px;
`;
